import { CurrentCustomer } from './CurrentCustomer';

const currentCustomer = CurrentCustomer.getInstance();

export { currentCustomer };
